import { createContext } from 'react';
export const createNameContext = (name, defaultValue) => {
    const context = createContext(defaultValue);
    context.displayName = name;
    return context;
};
//# sourceMappingURL=create-named-context.js.map